export default __webpack_public_path__ + "static/media/fad-punch-in.18cd4f5b.svg";